import { IconEyes } from '@ds/icons/IconEyes'
import { IconSparkles } from '@ds/icons/IconSparkles'

export const PICKER_ICONS = {
  IconEyes,
  IconSparkles,
}
